import { StructuredStorageSlots } from '../../constants';
import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class GetStructuredStorageSizeHelper extends StructuredStorageBaseHelper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitPushInt(node, StructuredStorageSlots.size);
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=GetStructuredStorageSizeHelper.js.map
